import { assignCommonProperties } from '../util/data/assign-common-properties.js'
import { jsonProperty, jsonClass } from '@sumbricht/json-class-serializer'

@jsonClass('DeploymentSource')
export class DeploymentSource {
	@jsonProperty(String)
	get __type() {
		return 'DeploymentSource'
	}
	set __type(_) {}
	@jsonProperty(Number)
	id?: number
	@jsonProperty(String)
	name?: string
	@jsonProperty(String)
	hostname?: string
	@jsonProperty(Number)
	port?: number
	@jsonProperty(String)
	publicKeyPem!: string
	@jsonProperty(String)
	privateKeyPem!: string

	constructor(init?: Partial<DeploymentSource>) {
		assignCommonProperties(this, init)
	}
}
